import { useSearchParams } from 'react-router-dom';
import { WorkerDataProvider } from 'public/components/common/worker-data-provider';
import { IdSubmissionContent } from './id-submission-content';

export const IdSubmission = () => {
  const [searchParams] = useSearchParams();
  const workerId = searchParams.get('workerId') ?? undefined;
  const dealId = searchParams.get('dealId') || null;

  return (
    <WorkerDataProvider workerId={workerId} verified={false}>
      {(data) => <IdSubmissionContent data={data} dealId={dealId} />}
    </WorkerDataProvider>
  );
};
